import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IRefreshSessionParams {
}

export interface IRefreshSessionInfoResult {
}

export class RefreshSessionRequest extends Request<IRefreshSessionParams, IRefreshSessionInfoResult> {
  constructor() {
    super('refreshSession', {});
  }
}